import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {

    zIndex: number;
    actingBodyId?: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function TagsDropdown({ value, setValue, zIndex, actingBodyId, form, fieldName }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getReportTags() {
        try {
            const tags = await dispatchService.getDropDownReportTags(actingBodyId);
            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getReportTags();
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('tags')}
            items={items}
            multiple={true}
            mode='BADGE'
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('tags')}
                items={items}
                setValue={setValue}
                value={value}
                multiple={true}
                mode='BADGE'
                zIndex={zIndex}
            />
        );
    }
}

export default TagsDropdown;
